<div *ngIf="task">

  <mat-card class="titleCard">
    <mat-list role="list">
      <mat-list-item role="listitem">
        <button mat-icon-button (click)="task.is_completed = !task.is_completed; updateTask(task)">
          <mat-icon [style.color]="task.is_completed ? '#039be5' : 'grey'">
            {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
        </button>
        <div *ngIf="!isEditable" (click)="isEditable = true" style="width: auto;">
          <h4 *ngIf="task.is_completed === false">
            {{task?.title}}
          </h4>
          <h4 *ngIf="task.is_completed === true">
            <del> {{task.title}}</del>
          </h4>
        </div>
        <div class="update" *ngIf="isEditable">
          <input [eguardAutofocus] on-focusout="isEditable = false" type="text" [(ngModel)]="task.title"
            (change)="updateTask(task);isEditable = false">
        </div>
        <mat-icon [matMenuTriggerFor]="menu" style="margin-left: 8px;cursor: pointer;">more_horiz</mat-icon>
        <mat-menu #menu="matMenu" class="optionList">
          <h6>Options</h6>
          <hr>
          <button mat-menu-item (click)="task.hideCompleteTask = !task.hideCompleteTask">
            <mat-icon class="iconFix" [style.color]="task.hideCompleteTask ? '#039be5' : 'grey'">
              {{task.hideCompleteTask ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
            <span class="fontFix">{{task.hideCompleteTask ? 'Show' : 'Hide'}} completed steps</span>
          </button>
        </mat-menu>

        <button mat-icon-button (click)="task.starred = !task.starred; updateTask(task)" style="margin-left: auto;">
          <mat-icon [style.color]="task.starred ? '#f1e789' : 'grey'">{{task.starred ? 'star' : 'star_border'}}
          </mat-icon>
        </button>
      </mat-list-item>
    </mat-list>

    <div class="steps" *ngIf="task.steps">
      <mat-list role="list">
        <mat-list-item role="listitem" [hidden]="task.hideCompleteTask && step.is_completed"
          *ngFor="let step of task?.steps" style="height: 25px;">
          <button mat-icon-button (click)="step.is_completed = !step.is_completed;updateSteps(step)">
            <mat-icon [style.color]=" step.is_completed ? '#039be5' : 'grey'">
              {{step.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
          </button>
          <div *ngIf="!step.isEditable" (click)="step.isEditable = true" style="width: 100%;">
            <span *ngIf="step.is_completed === false" style="text-transform: capitalize">
              {{step.title}}
            </span>
            <span *ngIf="step.is_completed === true" style="text-transform: capitalize">
              <del> {{step.title}}</del>
            </span>
          </div>
          <div class="update" *ngIf="step.isEditable">
            <input [eguardAutofocus] on-focusout="step.isEditable = false" type="text" [(ngModel)]="step.title"
              (change)="updateSteps(step);step.isEditable = false">
          </div>
          <button mat-icon-button (click)="deleteConfirmationSteps(step)" style="margin-left: auto;">
            <mat-icon [hidden]=" !step">close</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </div>

    <div class="add-new">
      <mat-icon>add</mat-icon>
      <input type="text" placeholder="Add  step" [(ngModel)]="stepName" (change)="addSteps(stepName)">
    </div>
  </mat-card>

  <mat-card class="addDay">
    <mat-icon [style.color]="task.my_day ? '#039be5' : '#34373d'" style="float: left;margin-top: -1px;">
      wb_sunny
    </mat-icon>
    <a (click)="addMyDay(task)" [style.color]="task.my_day ? '#039be5' : '#34373d'">
      Add to My Day
    </a>
    <mat-icon [hidden]="!task.my_day" class="close" (click)="removeMyDay(task)">close</mat-icon>
  </mat-card>

  <mat-card class="event" *ngIf="!task.due_date">
    <mat-datepicker #due disabled="false"></mat-datepicker>
    <mat-icon [style.color]="task.due_date ? '#039be5' : '#34373d'"
      style="float: left;margin-top: -3px;margin-right: 10px;">
      date_range
    </mat-icon>
    <a (click)="due.open()" [style.color]="task.due_date ? '#039be5' : '#34373d'" style="height: 21px;">
      <label>Add due date</label>
      <input matInput [(ngModel)]="task.due_date" (dateChange)="updateTask(task)" [matDatepicker]="due"
        placeholder="{{task.due_date |date}}" disabled style="background: white;font-size: 12px;">
    </a>
  </mat-card>

  <mat-card class="event" *ngIf="task.due_date">
    <mat-datepicker #due disabled="false"></mat-datepicker>
    <mat-icon style="float: left;margin-top: 7px;margin-right: 10px;color: #039be5;">
      date_range
    </mat-icon>
    <a (click)="due.open()" [style.color]="task.due_date ? '#039be5' : '#34373d'">
      <label style="margin-right: 70px;">Add due date</label>
      <input matInput [(ngModel)]="task.due_date" (dateChange)="updateTask(task)" [matDatepicker]="due"
        placeholder="{{task.due_date |date}}" disabled style="background: white;font-size: 12px;width: 70%;">
      <mat-icon [hidden]="!task.due_date" class="dateClose" (click)="removeDueDate(task)">close</mat-icon>
    </a>
  </mat-card>

  <mat-card style="padding: 10px 20px 10px 20px;">
    <h6 style="text-align: unset;margin-bottom: 10px;">Note</h6>
    <textarea matInput rows="4" [(ngModel)]="task.note" (change)="updateTask(task)">{{task.note}}</textarea>
  </mat-card>

  <mat-card style="padding: 10px 20px 55px 20px;height:auto">
    <h6 style="text-align: unset;margin-bottom: 10px;">Assign</h6>
    <user-selecter [task]="task" [type]="'assign'" (select)="selectedList($event)" [isSave]="isSave"></user-selecter>
    <div style="float: right;">
      <button mat-raised-button color="accent" (click)="assign()" [disabled]="users.length < 1">SUBMIT</button>
    </div>
  </mat-card>

  <mat-card style="padding: 10px 20px 10px 20px;height:auto">
    <h6 style="text-align: unset;margin-bottom: 10px;">Attachments</h6>
    <todo-uploader [project]="project" [task]="task"></todo-uploader>
  </mat-card>

  <mat-card style="margin-bottom:30px;">
    <h6 style="text-align: unset;margin-bottom: 10px;">Comments</h6>
    <todo-comments [mode]="TODO" [orgId]="orgId" [caseId]="task.id"></todo-comments>
  </mat-card>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-side-nav/todo-side-nav.component.html